import React, { useState } from "react";
import { AuthProvider } from "./context/AuthProvider";
import { MyRoutes } from "./routes/MyRoutes";
import { BrowserRouter } from "react-router-dom";


const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};

function App() {

  return (
        <BrowserRouter>
          <AuthProvider>            
                  <MyRoutes />            
          </AuthProvider>
        </BrowserRouter>
  );
}
export default App;
